import React, { useRef, useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate, HashRouter } from 'react-router-dom';
import ClippedDrawer from './components/Drawer/Drawer';
import './App.css';
import { AuthProvider } from './context/AuthProvider';
import { useSelector } from 'react-redux';
import LoginPage from './components/LoginPage/LoginPage';
import html2canvas from 'html2canvas';
import jwtDecode from 'jwt-decode';
import RedirectLogin from './components/RedirectLogin/RedirectLogin';


function App() {
  const ruser = useSelector((state) => state.globalData.user);
  const rtoken = useSelector((state) => state.globalData.token);
  const captureRef = useRef(null);
  
  // const handleContextMenu = (event) => {
  //   event.preventDefault(); // Prevent the default context menu from showing
  // };

  // const handleKeyDown = (event) => {
  //   if (event.code === 'KeyI' && event.ctrlKey && event.shiftKey) {
  //     event.preventDefault(); // Prevent opening the console when pressing Ctrl + Shift + I
  //   }
  // };

  // const handleWindowKeyDown = (event) => {
  //   if (event.code === 'F12') {
  //     event.preventDefault(); // Prevent opening the console when pressing F12
  //   }
  // };




  // useEffect(() => {
  //   window.addEventListener('contextmenu', handleContextMenu); // Add event listener to disable right-click on the entire page
  //   window.addEventListener('keydown', handleWindowKeyDown); // Add event listener to capture keydown events on the window

  //   return () => {
  //     window.removeEventListener('contextmenu', handleContextMenu); // Remove event listener when the component unmounts
  //     window.removeEventListener('keydown', handleWindowKeyDown); // Remove event listener when the component unmounts
  
  //   };
  // }, []);

  const isTokenExpired = () => {
    try {
      const token = rtoken;
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000; // Convert to seconds
      const diff = decodedToken.exp - currentTime;
  
      return diff <= 0 ? true : diff;
    } catch (error) {
     
      console.log("error in decoding the token");
      return true;
    }
  };
  
  const showExpiryAlert = (diff) => {
    const min = diff / 60;
    alert(`Please re-login again. The session is expiring in ${min} minutes.`);
  };
  
  const isAuthenticated = ruser !== null && rtoken !== null;
  const tokenExpired = isTokenExpired();
  

  const redirectToLoginPage = () => {
    // Replace this line with the actual code to redirect the user to the login page
    // For example:
    window.location.href = "/login";
  };

  
  if (isAuthenticated && tokenExpired !== true) {
    if (tokenExpired <= 300) {
      showExpiryAlert(tokenExpired);
    }
    if (tokenExpired === true) {
      console.log("token expired")
      redirectToLoginPage();
    }
  }

  
  
  
  
  


  return (
    <>
     
          <div 
          // onContextMenu={handleContextMenu} onKeyDown={handleKeyDown}
          >
            <Routes>
            <Route exact path="/redirectLogin" element={<RedirectLogin />} />
              <Route path="/*" element={isAuthenticated ? <ClippedDrawer ref={captureRef} /> : <Navigate to="/login" />} />
              <Route exact path="/login" element={<LoginPage />} />
            </Routes>
          </div>
       
    </>
  );
}

export default App;
